import { useSignals } from '@preact/signals-react/runtime'
import { DebugPanelTabs } from '../tabs/DebugPanelTabs'
import { useWebContainer } from '../../providers/DepProvider/DepProvider'

export function DebugPanelContainer() {
  useSignals()
  const container = useWebContainer()
  const debugPanelVM = container.debugPanelVM

  return (
    <DebugPanelTabs
      debugPanelVM={debugPanelVM}
      moveHistoryUI={container.moveHistoryUI}
      stateEditor={container.stateEditor}
      gamepadEmulation={container.gamepadEmulation}
    />
  )
}
